// DSS Documentation on Angular - http://tiny.sc/cgangular
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import $ from 'jquery';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

declare global {
    interface Window {
        ga(): void;
    }
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));

